<template lang="">
    <form id="soap_section">
        <div
            v-for="category in soapContent"
            :key="category.id"
            class="soap_section form_template_category"
        >
            <!-- Looping for each category -->
            <div class="row-fluid">
                <h4 :id="'title_' + category.label.toLowerCase()" href="#">
                    <i
                        :id="category.id + '_arrow'"
                        :class="ICON_SECTION_EXPANDED"
                        v-b-toggle="category.id"
                        style="vertical-align: inherit;"
                    ></i>
                    <a
                        :id="category.id + '_label'"
                        tabIndex="-1"
                        class="form_category_label text-link"
                        v-b-toggle="category.id"
                        >{{ category.label }}</a
                    >
                    <span class="field-locked-message"></span>
                </h4>
            </div>
            <!-- Looping for each component -->
            <div v-if="Object.values(category.data).length > 0">
                <b-collapse
                    v-for="component in Object.values(category.data)"
                    :key="component.id"
                    :id="category.id"
                    class="accordion-body collapse"
                    visible
                >
                    <div
                        class="form_template_component"
                        :ref="`${component.id}_section`"
                    >
                        <!-- component label-->
                        <div
                            v-if="
                                Object.values(component.data).length > 0 &&
                                component.id != 'fm_soap_diagnoses'
                            "
                            class="row-fluid"
                        >
                            <label>
                                <i
                                    :id="`${component.id}_arrow`"
                                    :class="ICON_SECTION_EXPANDED"
                                    v-b-toggle="`collapse_${component.id}`"
                                ></i>
                                <strong>
                                    <a
                                        :id="`${component.id}_label`"
                                        class="form_category_label text-link"
                                        v-b-toggle="`collapse_${component.id}`"
                                        >{{ component.label }}</a
                                    >
                                </strong>
                            </label>
                            <b-collapse
                                v-for="subcomponent in Object.values(
                                    component.data
                                )"
                                :key="subcomponent.id"
                                :id="`collapse_${component.id}`"
                                class="accordion-body collapse"
                                visible
                            >
                                <div
                                    class="form_template_subcomponent"
                                    :ref="`${subcomponent.id}_section`"
                                    :id="`${subcomponent.id}_section`"
                                >
                                    <!-- sub component label-->
                                    <div>
                                        <label
                                            v-if="
                                                subcomponent.data &&
                                                component &&
                                                component.data &&
                                                !checkHasComment(component.data)
                                            "
                                        >
                                            <i
                                                :id="`${subcomponent.id}_arrow`"
                                                :class="ICON_SECTION_EXPANDED"
                                                v-b-toggle="
                                                    `collapse_${subcomponent.id}`
                                                "
                                            ></i>
                                            <strong>
                                                <a
                                                    :id="`${subcomponent.id}_label`"
                                                    class="form_category_label text-link"
                                                    v-b-toggle="
                                                        `collapse_${subcomponent.id}`
                                                    "
                                                    >{{ subcomponent.label }}</a
                                                >
                                            </strong>
                                        </label>
                                        <b-form v-else class="row">
                                            <label
                                                :id="`${subcomponent.id}_label`"
                                                class="mt-1"
                                                :class="[labelCol]"
                                                >{{ `${subcomponent.label}:`
                                                }}<span
                                                    :ref="`${subcomponent.id}_changes_saved_label`"
                                                    class="d-none pl-0 auto-save-message"
                                                    >(changes saved)</span
                                                ></label
                                            >
                                            <div
                                                class="col-sm-2"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .isNumber
                                                "
                                            >
                                                <div class="row">
                                                    <b-form-input
                                                        :id="
                                                            renderBFormInput(
                                                                `${subcomponent.id}-value`,
                                                                subcomponent.value
                                                            )
                                                        "
                                                        :ref="`${subcomponent.id}-value`"
                                                        :disabled="isOfflined"
                                                        v-on:focus="
                                                            eventHandler(
                                                                `${subcomponent.id}-value`,
                                                                'focus'
                                                            )
                                                        "
                                                        v-on:blur="
                                                            bFormInputTriggerBlur(
                                                                `${subcomponent.id}-value`
                                                            )
                                                        "
                                                        v-on:update="
                                                            updateBFormInput(
                                                                `${subcomponent.id}-value`
                                                            )
                                                        "
                                                        v-model="
                                                            bFormInputValues[
                                                                `${subcomponent.id}-value`
                                                            ]
                                                        "
                                                        :placeholder="'Value'"
                                                        :class="`${
                                                            subcomponent.options
                                                                .defaultValue
                                                                ? 'col-sm'
                                                                : 'col-sm-11'
                                                        }`"
                                                    ></b-form-input>
                                                    <div
                                                        v-if="
                                                            subcomponent.options
                                                                .defaultValue
                                                        "
                                                        class="col-sm"
                                                        :class="`${
                                                            Object.values(
                                                                subcomponent
                                                                    .options
                                                                    .options
                                                            ).length == 1
                                                                ? 'mt-1'
                                                                : ''
                                                        }`"
                                                    >
                                                        <span
                                                            v-if="
                                                                Object.values(
                                                                    subcomponent
                                                                        .options
                                                                        .options
                                                                ).length == 1
                                                            "
                                                        >
                                                            {{
                                                                `${
                                                                    subcomponent
                                                                        .options
                                                                        .options[
                                                                        subcomponent
                                                                            .options
                                                                            .defaultValue
                                                                    ]
                                                                }`
                                                            }}
                                                            <input
                                                                type="hidden"
                                                                :id="`${subcomponent.id}-value_type`"
                                                                :name="`${subcomponent.id}-value_type`"
                                                                :value="
                                                                    subcomponent
                                                                        .options
                                                                        .defaultValue
                                                                "
                                                                :disabled="
                                                                    isOfflined
                                                                "
                                                            />
                                                        </span>
                                                        <b-form-select
                                                            v-else
                                                            :id="
                                                                renderBFormSelect(
                                                                    `${subcomponent.id}-value_type`,
                                                                    subcomponent
                                                                        .options
                                                                        .defaultValue
                                                                )
                                                            "
                                                            :ref="`${subcomponent.id}-value_type`"
                                                            :disabled="
                                                                isOfflined
                                                            "
                                                            @focus.native="
                                                                eventHandler(
                                                                    `${subcomponent.id}-value_type`,
                                                                    'focus'
                                                                )
                                                            "
                                                            @blur.native="
                                                                eventHandler(
                                                                    `${subcomponent.id}-value_type`,
                                                                    'out-focus'
                                                                )
                                                            "
                                                            @change="
                                                                updateFormSelect(
                                                                    `${subcomponent.id}-value_type`
                                                                )
                                                            "
                                                            v-model="
                                                                selectedBFormSelectValues[
                                                                    `${subcomponent.id}-value_type`
                                                                ]
                                                            "
                                                        >
                                                            <option
                                                                v-for="(value,
                                                                key) in subcomponent
                                                                    .options
                                                                    .options"
                                                                :key="key"
                                                                :value="key"
                                                                >{{
                                                                    value
                                                                }}</option
                                                            >
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="col-sm-2 remove-padding-left-custom"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .options &&
                                                    Object.values(
                                                        subcomponent.options
                                                            .options
                                                    ).length > 0 &&
                                                    !subcomponent.options
                                                        .isNumber &&
                                                    subcomponent.options
                                                        .elementValue != '' &&
                                                    !subcomponent.options
                                                        .isDatePicker
                                                "
                                            >
                                                <b-form-select
                                                    v-if="
                                                        !subcomponent.options
                                                            .isMultiple
                                                    "
                                                    :id="
                                                        renderBFormSelect(
                                                            `${subcomponent.id}-value`,
                                                            subcomponent.value !=
                                                                ''
                                                                ? subcomponent.value
                                                                : subcomponent
                                                                      .options
                                                                      .defaultValue
                                                        )
                                                    "
                                                    :ref="`${subcomponent.id}-value`"
                                                    @focus.native="
                                                        eventHandler(
                                                            `${subcomponent.id}-value`,
                                                            'focus'
                                                        )
                                                    "
                                                    @blur.native="
                                                        eventHandler(
                                                            `${subcomponent.id}-value`,
                                                            'out-focus'
                                                        )
                                                    "
                                                    @change="
                                                        updateFormSelect(
                                                            `${subcomponent.id}-value`
                                                        )
                                                    "
                                                    v-model="
                                                        selectedBFormSelectValues[
                                                            `${subcomponent.id}-value`
                                                        ]
                                                    "
                                                    class="form-control"
                                                    :disabled="isOfflined"
                                                >
                                                    <option
                                                        v-for="(value,
                                                        key) in subcomponent
                                                            .options.options"
                                                        :key="key"
                                                        :value="key"
                                                        >{{ value }}</option
                                                    ></b-form-select
                                                >
                                                <v-select
                                                    v-else-if="
                                                        subcomponent.options
                                                            .isMultiple
                                                    "
                                                    :id="`${subcomponent.id}-value`"
                                                    :ref="`${subcomponent.id}-value`"
                                                    :options="
                                                        filterOptions(
                                                            selectOptions[
                                                                `${subcomponent.id}-value`
                                                            ],
                                                            `${subcomponent.id}-value`
                                                        )
                                                    "
                                                    v-model="
                                                        selectedVSelectValues[
                                                            `${subcomponent.id}-value`
                                                        ]
                                                    "
                                                    @search:focus="
                                                        eventHandler(
                                                            `${subcomponent.id}-value`,
                                                            'focus',
                                                            true
                                                        )
                                                    "
                                                    @search:blur="
                                                        vSelectTriggerBlur(
                                                            `${subcomponent.id}-value`
                                                        )
                                                    "
                                                    @input="
                                                        debouncedSoapFieldSave(
                                                            `${subcomponent.id}-value`,
                                                            false,
                                                            true,
                                                            'input-vselect'
                                                        )
                                                    "
                                                    :disabled="
                                                        checkLockedElement(
                                                            `${subcomponent.id}-value`
                                                        )
                                                    "
                                                    multiple
                                                    append-to-body
                                                    label="label"
                                                />
                                            </div>

                                            <div
                                                class="col-sm-2 remove-padding-left-custom"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .options2 &&
                                                    Object.values(
                                                        subcomponent.options
                                                            .options2
                                                    ).length > 0 &&
                                                    subcomponent.options
                                                        .defaultValue2
                                                "
                                            >
                                                <b-form-select
                                                    :id="
                                                        renderBFormSelect(
                                                            `${subcomponent.id}-value2`,
                                                            subcomponent.value2 !=
                                                                ''
                                                                ? subcomponent.value2
                                                                : subcomponent
                                                                      .options
                                                                      .defaultValue2
                                                        )
                                                    "
                                                    :ref="`${subcomponent.id}-value2`"
                                                    @focus.native="
                                                        eventHandler(
                                                            `${subcomponent.id}-value2`,
                                                            'focus'
                                                        )
                                                    "
                                                    @blur.native="
                                                        eventHandler(
                                                            `${subcomponent.id}-value2`,
                                                            'out-focus'
                                                        )
                                                    "
                                                    @change="
                                                        updateFormSelect(
                                                            `${subcomponent.id}-value2`
                                                        )
                                                    "
                                                    class="form-control"
                                                    v-model="
                                                        selectedBFormSelectValues[
                                                            `${subcomponent.id}-value2`
                                                        ]
                                                    "
                                                    :options="
                                                        subcomponent.options
                                                            .options2
                                                    "
                                                    :disabled="isOfflined"
                                                ></b-form-select>
                                            </div>

                                            <date-picker
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .isDatePicker
                                                "
                                                :config="options"
                                                :id="subcomponent.id"
                                                :placeholder="getDateFormat()"
                                                :disabled="isOfflined"
                                                :value="
                                                    subcomponent.comment
                                                        ? new Date(
                                                              subcomponent.comment *
                                                                  1000
                                                          )
                                                        : null
                                                "
                                                class="col-sm remove-padding-left-custom"
                                                @dp-show="
                                                    eventHandler(
                                                        subcomponent.id,
                                                        'focus'
                                                    )
                                                "
                                                @dp-hide="
                                                    eventHandler(
                                                        subcomponent.id,
                                                        'out-focus'
                                                    )
                                                "
                                                @dp-change="handleDateChange"
                                            />
                                            <editable
                                                v-else
                                                :ref="`editable-${subcomponent.id}`"
                                                :divId="`${subcomponent.id}`"
                                                :value="subcomponent.comment"
                                                :disabled="isOfflined"
                                                :isDebounceInput="true"
                                                @update="
                                                    updateEditable(
                                                        `${subcomponent.id}`,
                                                        'updateEditable'
                                                    )
                                                "
                                                @socket-update="
                                                    triggerUpdateSocket
                                                "
                                                @focus="
                                                    eventHandler(
                                                        subcomponent.id,
                                                        'focus'
                                                    )
                                                "
                                                @blur="
                                                    editableTriggerBlur(
                                                        subcomponent.id
                                                    )
                                                "
                                                :placeholder="
                                                    placeholderEditable(
                                                        subcomponent
                                                    )
                                                "
                                                :defaultHeight="defaultHeight"
                                                :resizeHeight="true"
                                                class="col-sm remove-padding-left-custom"
                                            ></editable>
                                        </b-form>
                                    </div>
                                    <!-- Looping for each sub sub component -->
                                    <div
                                        v-if="
                                            subcomponent.data &&
                                            Object.values(subcomponent.data)
                                                .length > 0
                                        "
                                    >
                                        <b-collapse
                                            v-for="subsubcomponent in Object.values(
                                                subcomponent.data
                                            )"
                                            :key="subsubcomponent.id"
                                            :id="`collapse_${subcomponent.id}`"
                                            class="accordion-body collapse"
                                            visible
                                        >
                                            <div
                                                class="form_template_sub_subcomponent"
                                                :ref="`${subsubcomponent.id}_section`"
                                            >
                                                <div class="row">
                                                    <label
                                                        :id="`${subsubcomponent.id}_label`"
                                                        class="mt-1"
                                                        :class="[labelCol]"
                                                    >
                                                        {{
                                                            subsubcomponent.label
                                                        }}:<span
                                                            :ref="`${subsubcomponent.id}_changes_saved_label`"
                                                            class="d-none pl-0 auto-save-message"
                                                            >(changes
                                                            saved)</span
                                                        >
                                                    </label>

                                                    <div
                                                        class="col-sm-2"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .isNumber
                                                        "
                                                    >
                                                        <div class="row">
                                                            <b-form-input
                                                                :class="`${
                                                                    subsubcomponent.value_type
                                                                        ? 'col-sm'
                                                                        : 'col-sm-11'
                                                                }`"
                                                                :id="
                                                                    renderBFormInput(
                                                                        `${subsubcomponent.id}-value`,
                                                                        subsubcomponent.value
                                                                    )
                                                                "
                                                                :ref="`${subsubcomponent.id}-value`"
                                                                v-on:focus="
                                                                    eventHandler(
                                                                        `${subsubcomponent.id}-value`,
                                                                        'focus'
                                                                    )
                                                                "
                                                                v-on:blur="
                                                                    bFormInputTriggerBlur(
                                                                        `${subsubcomponent.id}-value`
                                                                    )
                                                                "
                                                                v-on:update="
                                                                    updateBFormInput(
                                                                        `${subsubcomponent.id}-value`
                                                                    )
                                                                "
                                                                v-model="
                                                                    bFormInputValues[
                                                                        `${subsubcomponent.id}-value`
                                                                    ]
                                                                "
                                                                :placeholder="'Value'"
                                                                :disabled="
                                                                    isOfflined
                                                                "
                                                            ></b-form-input>
                                                            <div
                                                                v-if="
                                                                    subsubcomponent.value_type
                                                                "
                                                                class="col-sm"
                                                                :class="`${
                                                                    Object.values(
                                                                        subsubcomponent
                                                                            .options
                                                                            .options
                                                                    ).length ==
                                                                    1
                                                                        ? 'mt-1'
                                                                        : ''
                                                                }`"
                                                            >
                                                                <span
                                                                    v-if="
                                                                        Object.values(
                                                                            subsubcomponent
                                                                                .options
                                                                                .options
                                                                        )
                                                                            .length ==
                                                                        1
                                                                    "
                                                                >
                                                                    {{
                                                                        `${
                                                                            subsubcomponent
                                                                                .options
                                                                                .options[
                                                                                subsubcomponent
                                                                                    .value_type
                                                                            ]
                                                                        }`
                                                                    }}
                                                                    <input
                                                                        type="hidden"
                                                                        :id="`${subsubcomponent.id}-value_type`"
                                                                        :ref="`${subsubcomponent.id}-value_type`"
                                                                        :name="`${subsubcomponent.id}-value_type`"
                                                                        :value="
                                                                            subsubcomponent
                                                                                .options
                                                                                .defaultValue
                                                                        "
                                                                        :disabled="
                                                                            isOfflined
                                                                        "
                                                                    />
                                                                </span>
                                                                <b-form-select
                                                                    v-else
                                                                    :id="
                                                                        renderBFormSelect(
                                                                            `${subsubcomponent.id}-value_type`,
                                                                            subsubcomponent.value_type
                                                                                ? subsubcomponent.value_type
                                                                                : subsubcomponent
                                                                                      .options
                                                                                      .defaultValue
                                                                        )
                                                                    "
                                                                    :ref="`${subsubcomponent.id}-value_type`"
                                                                    :disabled="
                                                                        isOfflined
                                                                    "
                                                                    @focus.native="
                                                                        eventHandler(
                                                                            `${subsubcomponent.id}-value_type`,
                                                                            'focus'
                                                                        )
                                                                    "
                                                                    @blur.native="
                                                                        eventHandler(
                                                                            `${subsubcomponent.id}-value_type`,
                                                                            'out-focus'
                                                                        )
                                                                    "
                                                                    @change="
                                                                        updateFormSelect(
                                                                            `${subsubcomponent.id}-value_type`
                                                                        )
                                                                    "
                                                                    v-model="
                                                                        selectedBFormSelectValues[
                                                                            `${subsubcomponent.id}-value_type`
                                                                        ]
                                                                    "
                                                                >
                                                                    <option
                                                                        v-for="(value,
                                                                        key) in subsubcomponent
                                                                            .options
                                                                            .options"
                                                                        :key="
                                                                            key
                                                                        "
                                                                        :value="
                                                                            key
                                                                        "
                                                                        >{{
                                                                            value
                                                                        }}</option
                                                                    >
                                                                </b-form-select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-2 remove-padding-left-custom"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .options &&
                                                            Object.values(
                                                                subsubcomponent
                                                                    .options
                                                                    .options
                                                            ).length > 0 &&
                                                            !subsubcomponent
                                                                .options
                                                                .isNumber &&
                                                            subsubcomponent
                                                                .options
                                                                .elementValue !=
                                                                '' &&
                                                            !subsubcomponent
                                                                .options
                                                                .isDatePicker
                                                        "
                                                    >
                                                        <b-form-select
                                                            v-if="
                                                                Array.isArray(
                                                                    subsubcomponent.options
                                                                ) != true &&
                                                                !subsubcomponent
                                                                    .options
                                                                    .isMultiple
                                                            "
                                                            :id="
                                                                renderBFormSelect(
                                                                    `${subsubcomponent.id}-value`,
                                                                    subsubcomponent.value
                                                                        ? subsubcomponent.value
                                                                        : subsubcomponent
                                                                              .options
                                                                              .defaultValue
                                                                )
                                                            "
                                                            :ref="`${subsubcomponent.id}-value`"
                                                            @focus.native="
                                                                eventHandler(
                                                                    `${subsubcomponent.id}-value`,
                                                                    'focus'
                                                                )
                                                            "
                                                            @blur.native="
                                                                eventHandler(
                                                                    `${subsubcomponent.id}-value`,
                                                                    'out-focus'
                                                                )
                                                            "
                                                            @change="
                                                                updateFormSelect(
                                                                    `${subsubcomponent.id}-value`
                                                                )
                                                            "
                                                            v-model="
                                                                selectedBFormSelectValues[
                                                                    `${subsubcomponent.id}-value`
                                                                ]
                                                            "
                                                            :disabled="
                                                                isOfflined
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="(value,
                                                                key) in subsubcomponent
                                                                    .options
                                                                    .options"
                                                                :key="key"
                                                                :value="key"
                                                                >{{
                                                                    value
                                                                }}</option
                                                            ></b-form-select
                                                        >
                                                        <v-select
                                                            v-else-if="
                                                                subsubcomponent
                                                                    .options
                                                                    .isMultiple
                                                            "
                                                            :id="`${subsubcomponent.id}-value`"
                                                            :ref="`${subsubcomponent.id}-value`"
                                                            :options="
                                                                filterOptions(
                                                                    selectOptions[
                                                                        `${subsubcomponent.id}-value`
                                                                    ],
                                                                    `${subsubcomponent.id}-value`
                                                                )
                                                            "
                                                            v-model="
                                                                selectedVSelectValues[
                                                                    `${subsubcomponent.id}-value`
                                                                ]
                                                            "
                                                            @search:focus="
                                                                eventHandler(
                                                                    `${subsubcomponent.id}-value`,
                                                                    'focus',
                                                                    true
                                                                )
                                                            "
                                                            @search:blur="
                                                                vSelectTriggerBlur(
                                                                    `${subsubcomponent.id}-value`
                                                                )
                                                            "
                                                            @input="
                                                                debouncedSoapFieldSave(
                                                                    `${subsubcomponent.id}-value`,
                                                                    false,
                                                                    true,
                                                                    'input-vselect'
                                                                )
                                                            "
                                                            :disabled="
                                                                checkLockedElement(
                                                                    `${subsubcomponent.id}-value`
                                                                )
                                                            "
                                                            multiple
                                                            append-to-body
                                                            label="label"
                                                        />
                                                    </div>

                                                    <div
                                                        class="col-sm-2 remove-padding-left-custom"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .options2 &&
                                                            Object.values(
                                                                subsubcomponent
                                                                    .options
                                                                    .options2
                                                            ).length > 0 &&
                                                            subsubcomponent
                                                                .options
                                                                .defaultValue2
                                                        "
                                                    >
                                                        <b-form-select
                                                            :id="
                                                                renderBFormSelect(
                                                                    `${subsubcomponent.id}-value2`,
                                                                    subsubcomponent.value2 !=
                                                                        ''
                                                                        ? subsubcomponent.value2
                                                                        : subsubcomponent
                                                                              .options
                                                                              .defaultValue2
                                                                )
                                                            "
                                                            :ref="`${subsubcomponent.id}-value2`"
                                                            @focus.native="
                                                                eventHandler(
                                                                    `${subsubcomponent.id}-value2`,
                                                                    'focus'
                                                                )
                                                            "
                                                            @blur.native="
                                                                eventHandler(
                                                                    `${subsubcomponent.id}-value2`,
                                                                    'out-focus'
                                                                )
                                                            "
                                                            @change="
                                                                updateFormSelect(
                                                                    `${subsubcomponent.id}-value2`
                                                                )
                                                            "
                                                            class="form-control"
                                                            v-model="
                                                                selectedBFormSelectValues[
                                                                    `${subsubcomponent.id}-value2`
                                                                ]
                                                            "
                                                            :options="
                                                                subsubcomponent
                                                                    .options
                                                                    .options2
                                                            "
                                                            :disabled="
                                                                isOfflined
                                                            "
                                                        ></b-form-select>
                                                    </div>

                                                    <editable
                                                        :ref="`editable-${subsubcomponent.id}`"
                                                        :divId="`${subsubcomponent.id}`"
                                                        :value="
                                                            subsubcomponent.comment
                                                        "
                                                        :isDebounceInput="true"
                                                        @update="
                                                            updateEditable(
                                                                `${subsubcomponent.id}`,
                                                                'updateEditable'
                                                            )
                                                        "
                                                        @socket-update="
                                                            triggerUpdateSocket
                                                        "
                                                        @focus="
                                                            eventHandler(
                                                                subsubcomponent.id,
                                                                'focus'
                                                            )
                                                        "
                                                        @blur="
                                                            editableTriggerBlur(
                                                                subsubcomponent.id
                                                            )
                                                        "
                                                        :placeholder="
                                                            placeholderEditable(
                                                                subsubcomponent
                                                            )
                                                        "
                                                        :defaultHeight="
                                                            defaultHeight
                                                        "
                                                        :resizeHeight="true"
                                                        class="col-sm remove-padding-left-custom"
                                                        :disabled="isOfflined"
                                                    ></editable>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div
                            v-if="component.id == 'fm_soap_diagnoses'"
                            :class="
                                component.data > 0 ? '' : 'table-responsive '
                            "
                            class="position-relative"
                        >
                            <span>
                                <h4 :id="`${component.id}_label`">
                                    Diagnoses
                                </h4>
                                <span
                                    class="component-title"
                                    v-if="!showDiagnosisComment(component.data)"
                                >
                                    <a
                                        v-if="
                                            !statusInActive &&
                                            _hasAccess(
                                                'patient.record.create'
                                            ) &&
                                            _hasAccess('patient.record.view')
                                        "
                                        href="javascript:void(0)"
                                        @click.stop.prevent="
                                            openModal(HISTORY.VIEWS.DIAGNOSES)
                                        "
                                        :class="{ 'disabled-link': isOfflined }"
                                        ><i class="cus-add"></i>Add Diagnosis</a
                                    ></span
                                >
                            </span>
                            <div v-if="showDiagnosisComment(component.data)">
                                <span
                                    v-for="subcomponent in component.data"
                                    :key="subcomponent.id"
                                >
                                    <template
                                        v-if="
                                            subcomponent.id ==
                                            'fm_soap_diagnoses_comment'
                                        "
                                    >
                                        <b-form
                                            v-if="subcomponent.comment"
                                            class="row"
                                        >
                                            <label
                                                :id="`${subcomponent.id}_label`"
                                                class="mt-1"
                                                :class="[labelCol]"
                                                >{{ `${subcomponent.label}:`
                                                }}<span
                                                    :ref="`${subcomponent.id}_changes_saved_label`"
                                                    class="d-none pl-0 auto-save-message"
                                                    >(changes saved)</span
                                                ></label
                                            >
                                            <editable
                                                :ref="`editable-${subcomponent.id}`"
                                                :divId="`${subcomponent.id}`"
                                                :value="subcomponent.comment"
                                                :isDebounceInput="true"
                                                @update="
                                                    updateEditable(
                                                        `${subcomponent.id}`,
                                                        'updateEditable'
                                                    )
                                                "
                                                @socket-update="
                                                    triggerUpdateSocket
                                                "
                                                @focus="
                                                    eventHandler(
                                                        `${subcomponent.id}`,
                                                        'focus'
                                                    )
                                                "
                                                @blur="
                                                    editableTriggerBlur(
                                                        subcomponent.id
                                                    )
                                                "
                                                :placeholder="
                                                    placeholderEditable(
                                                        subcomponent
                                                    )
                                                "
                                                :defaultHeight="defaultHeight"
                                                :resizeHeight="true"
                                                :disabled="isOfflined"
                                                class="col-sm remove-padding-left-custom"
                                            ></editable>
                                        </b-form>
                                        <DiagnosisList
                                            v-else
                                            class="soap-diagnosis-list"
                                            :patientId="soapDetails.patient_id"
                                            :isDisabled="isOfflined"
                                        />
                                    </template>
                                </span>
                            </div>
                            <DiagnosisList
                                v-else
                                class="soap-diagnosis-list"
                                :patientId="soapDetails.patient_id"
                                :isDisabled="isOfflined"
                            />
                        </div>
                        <div
                            v-if="component.id == 'fm_soap_plan_record'"
                            :id="component.id + '_label'"
                            class="position-relative"
                            visible
                        >
                            <SoapContentRecordList
                                :recordList="recordList"
                                :isRecordListLoading="isRecordListLoading"
                                :isDisabled="isOfflined"
                                @open-modal="openModal"
                                @reload-record-list="reloadRecordList"
                                @change-tab="changeTab"
                            />
                        </div>
                        <!-- Looping for each sub component -->
                        <b-form
                            v-if="
                                Object.values(component.data).length == 0 &&
                                component.id != 'fm_soap_diagnoses' &&
                                component.id != 'fm_soap_plan_record'
                            "
                            class="row"
                        >
                            <label
                                :id="`${component.id}_label`"
                                class="mt-1"
                                :class="[labelCol]"
                                for="inline-form-custom-select-pref"
                                >{{ `${component.label}:`
                                }}<span
                                    :ref="`${component.id}_changes_saved_label`"
                                    class="d-none pl-0 auto-save-message"
                                    >(changes saved)</span
                                ></label
                            >
                            <div
                                class="col-sm-2"
                                v-if="
                                    component.options &&
                                    component.options.isNumber
                                "
                            >
                                <div class="row">
                                    <b-form-input
                                        :class="`${
                                            component.options.defaultValue
                                                ? 'col-sm'
                                                : 'col-sm-11'
                                        }`"
                                        :id="
                                            renderBFormInput(
                                                `${component.id}-value`,
                                                component.value
                                            )
                                        "
                                        :ref="`${component.id}-value`"
                                        :disabled="isOfflined"
                                        v-on:focus="
                                            eventHandler(
                                                `${component.id}-value`,
                                                'focus'
                                            )
                                        "
                                        v-on:blur="
                                            bFormInputTriggerBlur(
                                                `${component.id}-value`
                                            )
                                        "
                                        v-on:update="
                                            updateBFormInput(
                                                `${component.id}-value`
                                            )
                                        "
                                        v-model="
                                            bFormInputValues[
                                                `${component.id}-value`
                                            ]
                                        "
                                        :placeholder="'Value'"
                                    ></b-form-input>
                                    <div
                                        v-if="component.options.defaultValue"
                                        class="col-sm"
                                        :class="`${
                                            Object.values(
                                                component.options.options
                                            ).length == 1
                                                ? 'mt-1'
                                                : ''
                                        }`"
                                    >
                                        <span
                                            v-if="
                                                Object.values(
                                                    component.options.options
                                                ).length == 1
                                            "
                                        >
                                            {{
                                                `${
                                                    component.options.options[
                                                        component.options
                                                            .defaultValue
                                                    ]
                                                }`
                                            }}
                                            <input
                                                type="hidden"
                                                :id="`${component.id}-value_type`"
                                                :ref="`${component.id}-value_type`"
                                                :name="`${component.id}-value_type`"
                                                :value="
                                                    component.options
                                                        .defaultValue
                                                "
                                                :disabled="isOfflined"
                                            />
                                        </span>
                                        <b-form-select
                                            v-else
                                            :id="
                                                renderBFormSelect(
                                                    `${component.id}-value_type`,
                                                    component.value_type
                                                        ? component.value_type
                                                        : component.options
                                                              .defaultValue
                                                )
                                            "
                                            :ref="`${component.id}-value_type`"
                                            @focus.native="
                                                eventHandler(
                                                    `${component.id}-value_type`,
                                                    'focus'
                                                )
                                            "
                                            @blur.native="
                                                eventHandler(
                                                    `${component.id}-value_type`,
                                                    'out-focus'
                                                )
                                            "
                                            @change="
                                                updateFormSelect(
                                                    `${component.id}-value_type`
                                                )
                                            "
                                            v-model="
                                                selectedBFormSelectValues[
                                                    `${component.id}-value_type`
                                                ]
                                            "
                                            :disabled="isOfflined"
                                        >
                                            <option
                                                v-for="(value, key) in component
                                                    .options.options"
                                                :key="key"
                                                :value="key"
                                                >{{ value }}</option
                                            >
                                        </b-form-select>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-sm-2 remove-padding-left-custom"
                                v-if="
                                    component.options &&
                                    component.options.options &&
                                    Object.values(component.options.options)
                                        .length > 0 &&
                                    !component.options.isNumber &&
                                    component.options.elementValue != '' &&
                                    !component.options.isDatePicker
                                "
                            >
                                <b-form-select
                                    v-if="
                                        Array.isArray(component.options) !=
                                            true &&
                                        !component.options.isMultiple
                                    "
                                    :id="
                                        renderBFormSelect(
                                            `${component.id}-value`,
                                            component.options.defaultValue,
                                            component
                                        )
                                    "
                                    :ref="`${component.id}-value`"
                                    :disabled="isOfflined"
                                    @focus.native="
                                        eventHandler(
                                            `${component.id}-value`,
                                            'focus'
                                        )
                                    "
                                    @blur.native="
                                        eventHandler(
                                            `${component.id}-value`,
                                            'out-focus'
                                        )
                                    "
                                    @change="
                                        updateFormSelect(
                                            `${component.id}-value`
                                        )
                                    "
                                    v-model="
                                        selectedBFormSelectValues[
                                            `${component.id}-value`
                                        ]
                                    "
                                    class="form-control"
                                >
                                    <option
                                        v-for="(value, key) in component.options
                                            .options"
                                        :key="key"
                                        :value="key"
                                        >{{ value }}</option
                                    ></b-form-select
                                >
                                <v-select
                                    v-else-if="component.options.isMultiple"
                                    :id="`${component.id}-value`"
                                    :ref="`${component.id}-value`"
                                    :options="
                                        filterOptions(
                                            selectOptions[
                                                `${component.id}-value`
                                            ],
                                            `${component.id}-value`
                                        )
                                    "
                                    v-model="
                                        selectedVSelectValues[
                                            `${component.id}-value`
                                        ]
                                    "
                                    @search:focus="
                                        eventHandler(
                                            `${component.id}-value`,
                                            'focus',
                                            true
                                        )
                                    "
                                    @search:blur="
                                        vSelectTriggerBlur(
                                            `${component.id}-value`
                                        )
                                    "
                                    @input="
                                        debouncedSoapFieldSave(
                                            `${component.id}-value`,
                                            false,
                                            true,
                                            'input-vselect'
                                        )
                                    "
                                    :disabled="
                                        checkLockedElement(
                                            `${component.id}-value`
                                        )
                                    "
                                    multiple
                                    append-to-body
                                    label="label"
                                />
                            </div>

                            <div
                                class="col-sm-2 remove-padding-left-custom"
                                v-if="
                                    component.options &&
                                    component.options.options2 &&
                                    Object.values(component.options.options2)
                                        .length > 0 &&
                                    component.options.defaultValue2
                                "
                            >
                                <b-form-select
                                    :id="
                                        renderBFormSelect(
                                            `${component.id}-value2`,
                                            component.value2 != ''
                                                ? component.value2
                                                : component.options
                                                      .defaultValue2
                                        )
                                    "
                                    :ref="`${component.id}-value2`"
                                    @focus.native="
                                        eventHandler(
                                            `${component.id}-value2`,
                                            'focus'
                                        )
                                    "
                                    @blur.native="
                                        eventHandler(
                                            `${component.id}-value2`,
                                            'out-focus'
                                        )
                                    "
                                    @change="
                                        updateFormSelect(
                                            `${component.id}-value2`
                                        )
                                    "
                                    class="form-control"
                                    v-model="
                                        selectedBFormSelectValues[
                                            `${component.id}-value2`
                                        ]
                                    "
                                    :options="component.options.options2"
                                    :disabled="isOfflined"
                                ></b-form-select>
                            </div>
                            <editable
                                :ref="`editable-${component.id}`"
                                :divId="`${component.id}`"
                                :value="component.comment"
                                :isDebounceInput="true"
                                @update="
                                    updateEditable(
                                        `${component.id}`,
                                        'updateEditable'
                                    )
                                "
                                @socket-update="triggerUpdateSocket"
                                @focus="eventHandler(component.id, 'focus')"
                                @blur="editableTriggerBlur(component.id)"
                                :placeholder="placeholderEditable(component)"
                                :defaultHeight="defaultHeight"
                                :resizeHeight="true"
                                :disabled="isOfflined"
                                class="col-sm remove-padding-left-custom"
                            ></editable>
                        </b-form>
                    </div>
                </b-collapse>
            </div>
        </div>
        <ScrollToTop :is-smooth="true" />
    </form>
</template>
<script>
import HISTORY from "@/constants/history";
import PatientSoapService from "@/services/patient/patient-soap";
import vSelect from "vue-select";
import { debounce, find, isUndefined } from "lodash";
import SoapContentMixin from "@/mixins/soap-content.js";
import SoapContentSocketMixin from "@/mixins/soap-content-socket.js";
import io from "socket.io-client";

const IS_NUMERIC = true;
const FROM_MODEL = true;
const TRIGGER_SOCKET_UPDATE = true;

export default {
    mixins: [SoapContentMixin, SoapContentSocketMixin],
    components: {
        vSelect,
        DiagnosisList: () =>
            import("@/components/patient-diagnosis/diagnosis-list"),
        SoapContentRecordList: () =>
            import("@/components/soap/soap-content-record-list"),
        editable: () => import("@/components/elements/editable-textarea"),
        ScrollToTop: () => import("@/components/commons/scroll-to-top")
    },
    props: {
        soapContent: {
            type: [Array, Object]
        },
        recordList: {
            type: Array
        },
        isRecordListLoading: {
            type: Boolean,
            default: false
        },
        activeTabIndex: {
            type: Number
        }
    },
    computed: {
        statusInActive() {
            return this.$store.getters["soap/patientStatusInActive"];
        },
        serverTimestampXMLContent() {
            return this.$store.getters["soap/serverTimestampXMLContent"];
        },
        initialTimestampXMLContent() {
            return this.$store.getters["soap/initialTimestampXMLContent"];
        },
        lockedElements() {
            return this.$store.getters["soap/lockedElements"];
        },
        isAddSnippetOpened() {
            return this.$store.getters["soap/isAddSnippetOpened"];
        },
        triggeredFromSoapContent() {
            return true;
        },
        soapPageInstance() {
            return this.$store.getters["soap/soapPageInstance"];
        },
        currentFocusedElementId() {
            return this.$store.getters["soap/currentFocusedElementId"];
        }
    },
    watch: {
        soapContent(value, newValue) {
            let selectOptions = {};
            let selectedVSelectValues = {};
            this.selectedBFormSelectValues = {}; // reset the value
            for (let fidx in value) {
                let category = value[fidx];
                if (category.data) {
                    Object.values(category.data).forEach(component => {
                        if (component.options) {
                            selectOptions[
                                `${component.id}-value`
                            ] = this.handleMultipleSelectValue(
                                component.options.options
                            );
                            selectedVSelectValues[
                                `${component.id}-value`
                            ] = this.handleMultipleSelectValue(
                                component.options.defaultValue
                            );
                        }
                        if (component.data) {
                            Object.values(component.data).forEach(
                                subcomponent => {
                                    if (subcomponent.options) {
                                        selectOptions[
                                            `${subcomponent.id}-value`
                                        ] = this.handleMultipleSelectValue(
                                            subcomponent.options.options
                                        );
                                        selectedVSelectValues[
                                            `${subcomponent.id}-value`
                                        ] = this.handleMultipleSelectValue(
                                            subcomponent.options.defaultValue
                                        );
                                    }
                                    if (subcomponent.data) {
                                        Object.values(
                                            subcomponent.data
                                        ).forEach(subsubcomponent => {
                                            if (subsubcomponent.options) {
                                                selectOptions[
                                                    `${subsubcomponent.id}-value`
                                                ] = this.handleMultipleSelectValue(
                                                    subsubcomponent.options
                                                        .options
                                                );
                                                selectedVSelectValues[
                                                    `${subsubcomponent.id}-value`
                                                ] = this.handleMultipleSelectValue(
                                                    subsubcomponent.options
                                                        .defaultValue
                                                );
                                            }
                                        });
                                    }
                                }
                            );
                        }
                    });
                }
            }
            this.selectOptions = selectOptions;
            this.selectedVSelectValues = selectedVSelectValues;

            this.$nextTick(() => {
                this.BCollapseEventListener();
            });
        }
    },
    created() {
        this.options.timeZone = this._timeZone;
        this.options.format = this.getDateFormat();
        window.addEventListener("beforeunload", this.beforeWindowUnload);
        window.addEventListener("online", this.updateOnlineStatus);
        window.addEventListener("offline", this.updateOfflineStatus);
    },
    data() {
        return {
            IS_NUMERIC,
            FROM_MODEL,
            TRIGGER_SOCKET_UPDATE,
            HISTORY: HISTORY,
            defaultHeight: 50, // in px
            selectOptions: null,
            selectedVSelectValues: null,
            selectedBFormSelectValues: {},
            bFormInputValues: {},
            disableOptions: null,
            options: {
                format: "DD/MM/YYYY",
                timeZone: null,
                useCurrent: false
            },
            currentFocusedVSelect: false,
            soapSocket: null,
            proceedSaveUpdate: true,
            soapChannel: "",
            isOfflined: false,
            isSocketDisconnectedManually: false,
            pingReceived: false
        };
    },
    mounted() {},
    beforeDestroy() {
        this.disconnectSocket();
        window.removeEventListener("beforeunload", this.beforeWindowUnload);
        window.removeEventListener("online", this.updateOnlineStatus);
        window.removeEventListener("offline", this.updateOfflineStatus);
    },
    methods: {
        renderBFormSelect(bformSelectId, defaultValue, component = null) {
            // send component if wanted to preselect the first option if empty

            // This function ensures the element uses v-model and a reactive property,
            // so that when dealing with sockets, other users receive the updated data.
            // It keeps the data in selectedBFormSelectValues instead of resetting it by using component.value.
            //
            // The value is set once to prevent it from reverting to the previous state on re-render.
            let selected = defaultValue;
            if (component && selected == "") {
                selected = Array.isArray(component.options.options)
                    ? component.options.options[0]
                    : Object.keys(component.options.options)[0];
            }
            if (!(bformSelectId in this.selectedBFormSelectValues)) {
                this.$set(
                    this.selectedBFormSelectValues,
                    bformSelectId,
                    selected
                );
            }
            return bformSelectId;
        },
        renderBFormInput(bformInputId, defaultValue) {
            // This function ensures the element uses v-model and a reactive property,
            // so that when dealing with sockets, other users receive the updated data.
            // It keeps the data in bFormInputValues instead of resetting it by using component.value.
            //
            // The value is set once to prevent it from reverting to the previous state on re-render.

            if (!(bformInputId in this.bFormInputValues)) {
                this.$set(this.bFormInputValues, bformInputId, defaultValue);
            }
            return bformInputId;
        },
        checkHasComment(data) {
            return data
                ? data[Object.keys(data)[0]]?.options?.hasComment
                : false;
        },
        showDiagnosisComment(componentData) {
            if (componentData.length > 0) {
                let subcomponent = find(componentData, {
                    id: "fm_soap_diagnoses_comment"
                });
                return Boolean(subcomponent?.comment);
            }

            return false;
        },
        updateOnlineStatus() {
            location.reload();
        },
        updateOfflineStatus() {
            this.isOfflined = true;
        },
        disconnectSocket() {
            if (this.soapSocket) {
                this.isSocketDisconnectedManually = true;
                this.soapSocket.disconnect();
                this.soapSocket.off();
                this.soapSocket = null;
            }
        },
        async checkSocketIsConnected() {
            const stateConnected = this.soapSocket && this.soapSocket.connected;

            this.checkSocketLive(); // emits ping-check with soapPageInstance

            const pingResult = await new Promise(resolve => {
                const timeout = setTimeout(() => {
                    resolve(false); // no response within 2s
                }, 2000);

                this.onPingReceived = () => {
                    clearTimeout(timeout);
                    resolve(true); // received within timeout
                };
            });
            return stateConnected && pingResult;
        },
        checkSocketLive() {
            try {
                this.pingReceived = false;
                this.soapSocket?.emit("medical-note", {
                    action: "ping-check",
                    soapPageInstance: this.soapPageInstance,
                    by: this.$root.currentActor.id
                });

                return true; // attempted
            } catch (e) {
                return false;
            }
        },
        checkLockedElement(elementId) {
            return (
                find(this.lockedElements, { id: elementId }) !== undefined ||
                this.isOfflined
            );
        },
        init() {
            this.initSocket();
        },
        async initSocket() {
            this.disconnectSocket();
            await this.$nextTick();
            this.soapChannel = "medical-note:" + this.soapDetails.id;
            this.soapSocket = io.connect(process.env.SOCKET_URL, {
                secure: true,
                query: {
                    soapChannel: this.soapChannel,
                    soapId: this.soapDetails.id,
                    userId: this.$root.currentActor.id
                }
            });

            let self = this;

            this.soapSocket.on("connect", () => {
                // Bind the handler to the channel after connect event to make sure when socket is auto reconnect, it re-bind with the handler
                self.soapSocket.off(self.soapChannel); // Remove first if any // Important when the socket is reconnect
                self.soapSocket.on(self.soapChannel, self.handleSocketMessage);
            });
            this.soapSocket.on("disconnect", reason => {
                // All reasons of disconnection will reload the medical note due to when the laptop is closed/sleep/idle(but browser enter sleep mode), the browser also enter sleep mode which unable to receive any messages. Even the socket reconnect, the message will not received by the browser.
                if (self.activeTabIndex === 0) {
                    if (this.isSocketDisconnectedManually) {
                        this.isSocketDisconnectedManually = false;
                    } else if (navigator?.onLine) {
                        // VET-9124 - Only online will reload, if offline, will do nothing as when network return online, the page will reload
                        console.error(
                            "(Socket Event) Socket is disconneted. Reloading..."
                        );
                        self.$emit("reload-tab");
                    }
                }
            });
        },
        filterOptions(options, elementId) {
            let opt = _.differenceWith(
                options,
                this.selectedVSelectValues[elementId],
                (arrVal, othVal) => {
                    return arrVal.id === othVal.id;
                }
            );
            return opt;
        },
        placeholderEditable(component) {
            return component.label.toLowerCase() === "notes"
                ? "Notes"
                : "Comment";
        },
        objectToArray(obj) {
            let arr = [];

            if (obj.length != undefined && obj.length > 0) {
                obj.forEach((key, index) => {
                    arr[index] = key;
                });
            } else {
                Object.keys(obj).forEach((key, index) => {
                    arr[index] = obj[key];
                });
            }
            return arr;
        },
        beforeWindowUnload() {
            if (this.currentFocusedElementId) {
                // Save the input field before reload or redirect to other website
                this.nodebouncedSoapFieldSave(
                    this.currentFocusedElementId,
                    false,
                    false,
                    true,
                    "beforewindowunload"
                );
            }
        },
        bFormInputTriggerBlur(elementId) {
            // Trigger blur for component b-form-input
            // Apply blur for all b-form-input elements as the issue of missing data related to vitals (VET-6559) has been resolved.
            // It is now safe to trigger save on blur, assuming no further issues with missing data (VET-1484),
            // which primarily the missing data were from textareas/editable
            //
            // This ensures that when a user enters data in the first input field and quickly moves to another,
            // the first field's value will be saved to the DB.

            this.nodebouncedSoapFieldSave(
                elementId,
                IS_NUMERIC,
                !FROM_MODEL,
                TRIGGER_SOCKET_UPDATE,
                "bFormInputTriggerBlur"
            );
            this.eventHandler(elementId, "out-focus", false);
        },
        updateBFormInput(id) {
            if (id.includes("vital_sign")) {
                // For vitals, debounce is needed to avoid issues like the DB saved "11" instead of "1111" as API that send value "11" was delayed and the API send "1111" is much faster.

                this.debouncedSoapFieldSaveVital(
                    id,
                    IS_NUMERIC, // isNumeric
                    !FROM_MODEL, // fromModel
                    "update-bforminput"
                );
            } else {
                this.debouncedSoapFieldSave(
                    id,
                    IS_NUMERIC, // isNumeric
                    !FROM_MODEL, // fromModel
                    "update-bforminput"
                );
            }
        },
        vSelectTriggerBlur(elementId) {
            // Trigger blur for component v-select
            // VET-1484 - Commented due to issue related to missing data
            // this.nodebouncedSoapFieldSave(
            //     elementId,
            //     !IS_NUMERIC,
            //     FROM_MODEL,
            //     TRIGGER_SOCKET_UPDATE,
            //     "vSelectTriggerBlur"
            // );

            this.eventHandler(elementId, "out-focus", true);
        },
        editableTriggerBlur(elementId) {
            // Trigger blur for component editable
            // VET-1484 - Commented due to issue related to missing data
            // this.updateEditable(elementId, "editableTriggerBlur");
            this.eventHandler(elementId, "out-focus", false);
        },
        eventHandler(elementId, action, vSelect = false) {
            let value = "";

            if (document.getElementById(elementId).contentEditable == "true") {
                value = document.getElementById(elementId).innerText;
            } else {
                value = document.getElementById(elementId).value;
            }

            if (action === "focus") {
                this.$store.commit(
                    "soap/setCurrentFocusedElementId",
                    elementId
                );
                this.currentFocusedVSelect = vSelect;
            } else if (action === "out-focus") {
                this.$store.commit("soap/setCurrentFocusedElementId", null);
                this.currentFocusedVSelect = false;
            }

            if (this.soapSocket) {
                this.soapSocket.emit("medical-note", {
                    action: action,
                    field: elementId,
                    value: action == "out-focus" ? value : "",
                    by: this.$root.currentActor.id,
                    name: this.$root.currentActor.fullname,
                    vSelect: vSelect
                });
            }
        },
        triggerUpdateSocket(elementId, value, vSelect = false) {
            if (elementId && !isUndefined(value) && this.soapSocket) {
                // Fire socket update to make sure other user get the latest editted input
                this.soapSocket.emit("medical-note", {
                    action: "update",
                    field: elementId,
                    value: value,
                    by: this.$root.currentActor.id,
                    name: this.$root.currentActor.fullname,
                    soapPageInstance: this.soapPageInstance,
                    vSelect: vSelect
                });
            }
        },
        updateEditable(elementId, triggeredAction) {
            this.nodebouncedSoapFieldSave(
                elementId,
                !IS_NUMERIC,
                !FROM_MODEL,
                !TRIGGER_SOCKET_UPDATE,
                triggeredAction
            );
        },
        // No debounce needed here, as the editable component already handles it internally.
        // VET-5499 - When editing and quickly switching input fields, debounce only triggers for the last field edited.
        // It should trigger for both inputs that were modified.

        nodebouncedSoapFieldSave(
            id, //1,2
            isNumeric = false,
            fromModel = false,
            triggerSocketUpdate = true,
            triggeredAction = ""
        ) {
            this.$store.commit("soap/pushHasSoapChanges");
            this.soapFieldSave(
                id,
                isNumeric,
                fromModel,
                triggerSocketUpdate,
                triggeredAction
            );
        },
        debouncedSoapFieldSaveVital: debounce(async function (
            id, //1,2
            isNumeric = false,
            fromModel = false,
            triggeredAction = ""
        ) {
            this.$store.commit("soap/pushHasSoapChanges");
            this.soapFieldSave(id, isNumeric, fromModel, true, triggeredAction);
        }, 300),
        debouncedSoapFieldSave: debounce(async function (
            id, //1,2
            isNumeric = false,
            fromModel = false,
            triggeredAction = ""
        ) {
            this.$store.commit("soap/pushHasSoapChanges");
            this.soapFieldSave(id, isNumeric, fromModel, true, triggeredAction);
        }, 500),
        updateFormSelect(elementId) {
            this.$store.commit("soap/pushHasSoapChanges");
            this.soapFieldSave(
                elementId,
                false,
                false,
                true,
                "change-bformselect"
            );
        },
        async soapFieldSave(
            elementId,
            isNumeric = false,
            fromModel = false,
            triggerSocketUpdate = true,
            triggeredAction = ""
        ) {
            let self = this;
            let value = "";
            let oumType = "";
            let element = document.getElementById(elementId);

            if (!element) {
                return;
            }

            try {
                const patientId = self.soapDetails?.patient_id;
                const soapId = self.soapDetails?.id;

                if (fromModel) {
                    value = self.selectedVSelectValues[elementId]
                        .map(option => option.id)
                        .join("$#");
                } else {
                    if (element.contentEditable == "true") {
                        value = element.innerText;
                    } else {
                        value = element.value;
                    }
                    if (isNumeric) {
                        let isnum = /^\d+(\.\d+)?$/.test(value);
                        if (value != "" && !isnum) {
                            element.classList.add("border-danger");
                            return;
                        } else {
                            element.classList.remove("border-danger");
                        }
                    }

                    const valueElement =
                        elementId.includes("value") &&
                        !elementId.includes("value_type");

                    if (valueElement) {
                        const lastIndex = elementId.lastIndexOf("-value");

                        if (lastIndex != 1) {
                            const commonPartElement = elementId.substring(
                                0,
                                lastIndex
                            );
                            const valueTypeElementId = `${commonPartElement}-value_type`;
                            const typeElement = document.getElementById(
                                valueTypeElementId
                            );

                            if (typeElement && typeElement.value) {
                                oumType = typeElement.value;
                            }
                        }
                    }
                }

                if (isUndefined(value)) {
                    return;
                }

                if (triggerSocketUpdate) {
                    let vSelect = triggeredAction === "input-vselect";
                    this.triggerUpdateSocket(elementId, value, vSelect);
                }
                const {
                    saveTimestamp,
                    timeSinceLoad
                } = this.getCurrentSaveTimestamp();

                let params = {
                    element: elementId,
                    value: value,
                    oumType: oumType,
                    isNumericInput: isNumeric,
                    saveTimestamp: saveTimestamp, // timestamp to check in BE either this API is after soap->update_at
                    triggeredAction: triggeredAction, // Send this param to store in log
                    timeSinceLoad: timeSinceLoad // Send this param to store in log
                };

                let isProceedSaving = true;
                if (
                    timeSinceLoad >= 1800 &&
                    triggeredAction === "beforewindowunload"
                ) {
                    // 1800 seconds = 30 minutes
                    isProceedSaving = false;
                }

                // TODO: Remove below once issue related to medical note missing value solved
                // VET-6559
                // eslint-disable-next-line no-undef
                if (typeof newrelic !== "undefined") {
                    // eslint-disable-next-line no-undef
                    newrelic.addPageAction(`soap-${soapId}`, {
                        soap_id: soapId,
                        staff_name: this.$root.currentActor.fullname,
                        saveTimestamp: saveTimestamp,
                        params,
                        triggered_action: triggeredAction,
                        serverTimestampXMLContent:
                            self.serverTimestampXMLContent,
                        initialTimestampXMLContent:
                            self.initialTimestampXMLContent,
                        timeSinceLoad: timeSinceLoad,
                        isProceedSaving: isProceedSaving
                    });
                }
                if (patientId && this.proceedSaveUpdate && isProceedSaving) {
                    await PatientSoapService.soapFieldSave(soapId, params).then(
                        res => {
                            if (res && res.code == 200) {
                                self.showSaveMessage(elementId);

                                if (this.soapSocket) {
                                    // Added a check to prevent console errors when emit is called on null.
                                    // This happens if the user edits a field and quickly switches tabs —
                                    // the data is saved in the DB, but by the time this runs, `this.soapSocket` is null due to the socket being disconnected.
                                    this.soapSocket.emit("medical-note", {
                                        action: "update",
                                        field: elementId,
                                        value: value,
                                        by: this.$root.currentActor.id,
                                        name: this.$root.currentActor.fullname,
                                        db_save: 1,
                                        db_success: true,
                                        db_value: res.response.value,
                                        vSelect: fromModel,
                                        soapPageInstance: self.soapPageInstance,
                                        triggered_action: triggeredAction // VET-6559 : Add the triggered action to log in BE
                                    });
                                }

                                if (res.response && res.response.update_tabs) {
                                    this.$emit("update-tabs-count", [
                                        "tabRecords"
                                    ]);
                                }

                                if (res.response && res.response.refresh) {
                                    this.$emit("reload");
                                }
                            }
                        }
                    );
                } else if (!isProceedSaving) {
                    throw new Error("Time since load pass 30 minutes");
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.$store.commit("soap/removeHasSoapChanges");
            }
        },
        getCurrentSaveTimestamp() {
            const currentTimestamp = Math.floor(this._now().toSeconds());
            const timeSinceLoad =
                currentTimestamp - this.initialTimestampXMLContent;
            return {
                saveTimestamp: this.serverTimestampXMLContent + timeSinceLoad,
                timeSinceLoad
            };
        },
        handleDateChange(selectedDate) {
            // Handle the selected date here
            if (selectedDate) {
                this.$store.commit("soap/pushHasSoapChanges");
                this.soapFieldSave(selectedDate.target.id, false);
            }
        },
        openModal(key) {
            this.$emit("open-modal", key);
        },
        changeTab() {
            this.$emit("change-tab");
        },
        reloadRecordList() {
            this.$emit("reload-record-list");
        },
        scrollToTitleContent(elementId) {
            const element = document.getElementById(elementId + "_label");

            if (element) {
                element.style.scrollMarginTop = "20px";
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                });
            }
        },
        showSaveMessage(id) {
            // Split the id to get the section component id as it has different multiple input postfix
            const inputPostfix = ["value", "value2", "value_type"];

            const idPostfix = id.split("-").pop();

            const hasInputPostfix = inputPostfix.includes(idPostfix);

            if (hasInputPostfix) {
                id = id.replace(`-${idPostfix}`, "");
            }

            const changesSavedLabelElement = Array.isArray(
                this.$refs[`${id}_changes_saved_label`]
            )
                ? this.$refs[`${id}_changes_saved_label`][0]
                : this.$refs[`${id}_changes_saved_label`];

            if (changesSavedLabelElement) {
                changesSavedLabelElement.classList.remove("d-none");
                changesSavedLabelElement.classList.add("d-block");

                setTimeout(() => {
                    changesSavedLabelElement.classList.remove("d-block");
                    changesSavedLabelElement.classList.add("d-none");
                }, 2000);
            }
        }
    }
};
</script>
<style scoped>
/* Same as in soap-content.js */
.form_template_category,
.form_preview_category {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_component label {
    font-weight: normal;
    font-size: 100%;
}

.form_template_subcomponent label,
.form_template_sub_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}

.input_label {
    font-weight: normal;
}

.category_label {
    font-weight: bold;
    font-size: 120%;
}

.form_template_component {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_preview_component {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_subcomponent,
.form_preview_subcomponent {
    background: #fff;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_sub_subcomponent,
.form_preview_sub_subcomponent {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

/*for patient medical note*/
.form_category {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_component label {
    font-weight: normal;
    font-size: 100%;
}

.form_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}

.form_sub_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}

.form_input_label {
    font-weight: normal;
}

.form_category_label {
    font-weight: bold;
    font-size: 120%;
}

.form_component {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_subcomponent {
    background: #fff;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_sub_subcomponent {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.label_value {
    font-weight: 0;
}

.field-locked-message,
.auto-save-message {
    padding-left: 9px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    color: #999999;
}
@media (min-width: 576px) {
    .remove-padding-left-custom {
        padding-left: 0px;
    }
}
.soap-diagnosis-list {
    overflow-x: auto !important;
}
#soap_section {
    overflow: auto;
}
.bg-save {
    background-color: #e4ebd7;
}
</style>
